import * as Yup from 'yup'

import { AD_FORMAT } from '../../../../../../../constants/ads'

import {
  CAROUSEL_ITEMS,
  CUSTOMIZED_STORY_FILE,
  FORMAT_OPTION,
  IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY
} from '../../../../fields'
import { mediaItemSchema, mediaItemShape } from '../../../../validation'
import { FILE_URL } from '../../../../../../ReusableFormFields/AdFileUpload/fields'

export function getValidationSchema() {
  return Yup.object({
    [CAROUSEL_ITEMS]: Yup.array().when(FORMAT_OPTION, {
      is: AD_FORMAT.carousel,
      then: () => Yup.array().of(mediaItemSchema),
      otherwise: () => Yup.array().notRequired()
    }),
    singleMediaItem: Yup.object().when(FORMAT_OPTION, {
      is: AD_FORMAT.single,
      then: () => Yup.object().shape(mediaItemShape),
      otherwise: () => Yup.object().notRequired()
    }),
    [CUSTOMIZED_STORY_FILE]: Yup.object().when([FORMAT_OPTION, IS_CURRENT_MEDIA_CUSTOMIZED_WITH_STORY], {
      is: (format, isCustomized) => format === AD_FORMAT.single && isCustomized,
      then: () =>
        Yup.object().shape({
          [FILE_URL]: Yup.string().required('Please select Image or Video file')
        }),
      otherwise: () => Yup.object().notRequired()
    })
  })
}
